import PropTypes from "prop-types";
import React, { useState, useCallback, useRef, useEffect } from "react";
import { Prompt } from "react-router-dom";

export default function UnsavedChangesPrompt({
  message = "Niezapisane zmiany zostaną utracone",
  children,
}) {
  const [changed, setChanged] = useState(false);
  const onSaveCbRef = useRef(null);
  const setIsEdited = useCallback(
    (state, cb) => {
      if (changed !== state) {
        setChanged(state);
        if (cb) {
          onSaveCbRef.current = cb;
        }
      }
    },
    [changed]
  );

  useEffect(() => {
    if (!changed && typeof onSaveCbRef.current === "function") {
      onSaveCbRef.current();
      onSaveCbRef.current = null;
    }
  }, [changed]);

  return (
    <>
      <Prompt when={changed} message={message} />
      {Array.isArray(children)
        ? children.map((node) => React.cloneElement(node, { setIsEdited }))
        : React.cloneElement(children, { setIsEdited })}
    </>
  );
}

UnsavedChangesPrompt.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string,
};

UnsavedChangesPrompt.defaultProps = {
  message: "Niezapisane zmiany zostaną utracone.",
};
